export const fmtEUR = (n) =>
  n === null || n === undefined
    ? "—"
    : n.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";

export const fmtDate = (iso) =>
  iso ? `${String(iso).slice(8, 10)}/${String(iso).slice(5, 7)}/${String(iso).slice(0, 4)}` : "—";

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  // Utilise les composants LOCAUX (getFullYear/getMonth/getDate) au lieu de toISOString
  // pour éviter un décalage de jour aux abords de minuit lorsque UTC est en avance/retard sur local.
  const j = String(d.getDate()).padStart(2, "0");
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const y = d.getFullYear();
  return `${j}/${m}/${y} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const fmtH = (h) => `${String(h).replace(".", ",")} h`;

export const initiales = (prenom, nom) =>
  `${(prenom || "?")[0] || ""}${(nom || "?")[0] || ""}`.toUpperCase();

export const nomClient = (c) => {
  if (!c) return "—";
  if (c.type === "societe") return c.raison_sociale || "—";
  return `${c.civilite || ""} ${c.prenom || ""} ${c.nom || ""}`.trim() || "—";
};

export const JOURS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
export const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

export const dateFrLongue = (iso) => {
  const d = new Date(iso + "T00:00:00");
  return `${JOURS[(d.getDay() + 6) % 7]} ${d.getDate()} ${MOIS[d.getMonth()]}`;
};

export const isoAddDays = (iso, n) => {
  // Parse en UTC pour éviter les décalages de fuseau horaire (bug : en France UTC+2,
  // le toISOString() renvoyait la date de la veille et neutralisait l'incrément)
  const d = new Date(iso + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

export const todayIso = () => {
  // Utilise la date LOCALE (pas UTC) pour éviter qu'en soirée on affiche la veille
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const j = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${j}`;
};

export const mondayOf = (iso) => {
  const d = new Date(iso + "T00:00:00Z");
  const day = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - day);
  return d.toISOString().slice(0, 10);
};
